//Views
//Views[Files]
const FILES_LIST_TABLE_HEADERS = [
    '#',
    'превью',
    'тип',
    'название',
    'описание',
    'размер',
    'дата создания',
    'статус',
    'удалить',
]
//Views[Users]
const USERS_LIST_TABLE_HEADERS = [
    '#',
    'фото',
    'имя',
    'фамилия',
    'отчество',
    'email',
    'телефон',
    'роль',
    'группа',
    'статус',
    'дата регистрации',
    'удалить',
]

//Views[Recipients]
const RECIPIENTS_LIST_TABLE_HEADERS = [
    '#',
    'телефон',
    'группа',
    'акция',
    'данные профиля',
    'sms',
    'подарок',
    'подтвержден',
    'статус',
    'дата регистрации / добавил',
    'удалить',
]

const PROMOTIONS_LIST_TABLE_HEADERS = [
    '#',
    'название',
    'станция',
    'приз',
    'правила',
    'статус',
    'активен до',
    'добавил',
    'изменить',
    'удалить',
]

export {
    FILES_LIST_TABLE_HEADERS,
    USERS_LIST_TABLE_HEADERS,
    RECIPIENTS_LIST_TABLE_HEADERS,
    PROMOTIONS_LIST_TABLE_HEADERS,
}